import{orgCodeSchema as e,orgNameSchema as t}from"../dto-schemas/org.schema.mjs";import{z as n}from"zod";const r=n.object({name:t,code:e}).strict();export{r as createOrgDto};
//# sourceMappingURL=create-org.dto.mjs.map